export const SummarizationServerEvents = {
  SUMMARIZATION_FINAL: "summarization_final",
  SUMMARIZATION_CHUNK: "summarization_chunk",
  SUMMARIZATION_ERROR: "summarization_error",
};

export const SummarizationClientEvents = {
  SUMMARIZATION_SUBSCRIBE: "summarization_subscribe",
};
